import { Button, Card, CardTitle, Input, Password, Toaster } from "@dune/ui";
import "@dune/ui/globals.css";
import { LoginBody } from "@dune/types";
import { Controller, useForm } from "react-hook-form";
import { useLoginUser } from "../../api/mutations/user.mutations";

export default function Login() {
	const {
		control,
		handleSubmit,
		formState: { errors },
	} = useForm<LoginBody>();
	const { mutate, isPending } = useLoginUser();

	const onSubmit = (data: LoginBody) => {
		mutate(data);
	};

	return (
		<>
			<Toaster />
			<div className="bg-background-blue h-screen flex items-center justify-center">
				<div className="absolute top-0 left-0 p-6">
					<img src="/dune_white_logo.png" alt="Dune Logo" className="w-32" />
				</div>
				<div>
					<Card className="p-10 flex flex-col gap-6 min-w-[420px] overflow-auto text-center">
						<CardTitle className="text-3xl">Se connecter à Dune</CardTitle>

						<form
							onSubmit={handleSubmit(onSubmit)}
							className="w-full flex flex-col gap-4"
						>
							<Input
								placeholder="Entrez votre email"
								error={errors.email?.message}
								label="Email"
								{...control.register("email", {
									required: "L'email est requis",
								})}
							/>

							<div className="flex flex-col items-start gap-1 w-full mb-4">
								<div>Mot de passe</div>
								<Controller
									name="password"
									control={control}
									rules={{ required: "Le mot de passe est requis" }}
									render={({ field }) => (
										<Password
											value={field.value}
											onChange={field.onChange}
											error={errors.password?.message}
										/>
									)}
								/>
								<div className="flex justify-end w-full">
									<a
										href="/auth/forget-password"
										className="text-text-blue hover:text-blue-700 font-semibold underline text-sm"
									>
										Mot de passe oublié ?
									</a>
								</div>
							</div>

							<Button
								type="submit"
								disabled={isPending}
								isLoading={isPending}
								size="lg"
							>
								Se connecter
							</Button>
						</form>
					</Card>
				</div>
			</div>
		</>
	);
}
